var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { notificationAtom } from "../../atoms";
import { Notification } from "./Notification";

const NotificationsContainer = () => {
  const timeout = Number.parseFloat(process.env.NOTIFICATION_DELAY || '6000');
  const [timerId, setTimerId] = useState();
  const notification = useAtomValue(notificationAtom);
  const resetAtom = useResetAtom(notificationAtom);
  const notificationIsSet = Boolean(notification.text && notification.type);

  useEffect(() => {
    if (notificationIsSet && !timerId) {
      const timer = setTimeout(() => {
        resetAtom();
      }, timeout);

      setTimerId(timer);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
        setTimerId(undefined);
      }
    };
  }, [resetAtom, notificationIsSet, timerId]);

  const onClickHandler = () => {
    resetAtom();
  };

  const handleMouseEnter = () => timerId && clearTimeout(timerId);

  const handleMouseLeave = () => {
    if (timerId) clearTimeout(timerId);

    const timer = setTimeout(() => {
      resetAtom();
    }, timeout);

    setTimerId(timer);
  };

  if (!notificationIsSet) {
    return /*#__PURE__*/_jsx("div", {});
  }

  return (/*#__PURE__*/
    _jsx("div", { className: "tw-content" }, void 0, /*#__PURE__*/
    _jsx("div", {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      className: "fixed z-10 w-4/5 bottom-1 left-2 md:w-2/5" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "shadow-lg", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Notification, {
      type: notification.type,
      text: notification.text,
      details: notification.details,
      heading: notification.heading,
      dismissAction: onClickHandler }
    )
    )
    )
    ));

};

export { NotificationsContainer };